<script>import { okhsl } from "../../../d3-mapp/color/index.js";
import SignalPlot2 from "./SignalPlot2.svelte";
import {} from "./SignalProjection.svelte";
import {} from "../types.js";
import { getTag, splineToPath } from "../../../dsp/signal/helpers/to-path.js";
import { locale } from "../../reports/global-store.js";
import {
  mapToHistogramData,
  mapToTagDefinitions,
  mapToTagMap
} from "./signal-plot-helpers.js";
import { timeRangeContextKey } from "../time-plot-context.js";
import { getContext } from "svelte";
import { Metronome } from "../../../dsp/signal/metronome.js";
export let signals;
export let title;
export let yAxisLabel;
export let colors = [okhsl("hsl(0,0%,0%,1.0)")];
export let undefinedColors = [okhsl("hsl(0,0%,30%,1.0)")];
export let scalarEther = true;
export let showAxis = true;
export let showThreshold = true;
export let showProjection = true;
export let showHistogram = true;
export let tags = void 0;
export let percentile;
const { range } = getContext(timeRangeContextKey);
$:
  splines = signals.map((signal) => signal.spline($range.start.getTime(), $range.end.getTime()));
let p;
$: {
  if (percentile !== void 0 && signals.length == 1 && $range.end.getTime() - $range.start.getTime() > signals[0].interval()) {
    try {
      p = signals[0].percentile(percentile, new Metronome($range.start.getTime(), $range.end.getTime(), signals[0].interval(), false));
    } catch (error) {
      p = void 0;
    }
  } else {
    p = void 0;
  }
}
let tagDefinitions = [];
let graphStrokes;
let projectionData;
let histogramData;
$: {
  tagDefinitions = mapToTagDefinitions(showThreshold ? tags : [], $locale);
  graphStrokes = mapToTagMap(
    tagDefinitions,
    colors,
    undefinedColors,
    $locale
  );
}
$:
  paths = splines.map((spline) => splineToPath(spline, tagDefinitions));
$: {
  projectionData = paths.map((path) => {
    let tags2 = path.map((pathSection) => ({
      tag: getTag(pathSection),
      start: pathSection.meta.tStart,
      end: pathSection.meta.tEnd
    }));
    return tags2;
  });
  histogramData = mapToHistogramData(graphStrokes, projectionData[0]);
}
</script>

<SignalPlot2
  title={title + (percentile!==undefined && p!==undefined  ? ` (P${percentile*100}th%=${p.toFixed(2)})`:"")}
  label={yAxisLabel}
  labelSwatch={colors.length === 1 ? colors[0] : undefined}
  {tags}
  {scalarEther}
  {showAxis}
  {showThreshold}
  {showProjection}
  {showHistogram}
  {paths}
  {projectionData}
  {histogramData}
  {graphStrokes}
/>
